export const GET_TRANSFERORDERS_REQUEST = "GET_TRANSFERORDERS_REQUEST";
export const GET_TRANSFERORDERS_SUCCESS = "GET_TRANSFERORDERS_SUCCESS";
export const GET_TRANSFERORDERS_FAILURE = "GET_TRANSFERORDERS_FAILURE";

export const CREATE_TRANSFER_ORDER_REQUEST = "CREATE_TRANSFER_ORDER_REQUEST";
export const CREATE_TRANSFER_ORDER_SUCCESS = "CREATE_TRANSFER_ORDER_SUCCESS";
export const CREATE_TRANSFER_ORDER_FAILURE = "CREATE_TRANSFER_ORDER_FAILURE";

export const DOWNLOAD_TRANSFER_ORDER_REQUEST =
  "DOWNLOAD_TRANSFER_ORDER_REQUEST";
export const DOWNLOAD_TRANSFER_ORDER_SUCCESS =
  "DOWNLOAD_TRANSFER_ORDER_SUCCESS";
export const DOWNLOAD_TRANSFER_ORDER_FAILURE =
  "DOWNLOAD_TRANSFER_ORDER_FAILURE";

export const CREATE_TRANSFER_ORDER_FOR_QTY_REQUEST =
  "CREATE_TRANSFER_ORDER_FOR_QTY_REQUEST";
export const CREATE_TRANSFER_ORDER_FOR_QTY_SUCCESS =
  "CREATE_TRANSFER_ORDER_FOR_QTY_SUCCESS";
export const CREATE_TRANSFER_ORDER_FOR_QTY_FAILURE =
  "CREATE_TRANSFER_ORDER_FOR_QTY_FAILURE";

export const GET_SUIDS_REQUEST = "GET_SUIDS_REQUEST";
export const GET_SUIDS_SUCCESS = "GET_SUIDS_SUCCESS";
export const GET_SUIDS_FAILURE = "GET_SUIDS_FAILURE";

export const GET_AVAILABLEQTYFORTO_REQUEST = "GET_AVAILABLEQTYFORTO_REQUEST";
export const GET_AVAILABLEQTYFORTO_SUCCESS = "GET_AVAILABLEQTYFORTO_SUCCESS";
export const GET_AVAILABLEQTYFORTO_FAILURE = "GET_AVAILABLEQTYFORTO_FAILURE";

export const GET_WAREHOUSES_BY_ITEM_ID_MOVEMENT_REQUEST =
  "GET_WAREHOUSES_BY_ITEM_ID_MOVEMENT_REQUEST";
export const GET_WAREHOUSES_BY_ITEM_ID_MOVEMENT_SUCCESS =
  "GET_WAREHOUSES_BY_ITEM_ID_MOVEMENT_SUCCESS";
export const GET_WAREHOUSES_BY_ITEM_ID_MOVEMENT_FAILURE =
  "GET_WAREHOUSES_BY_ITEM_ID_MOVEMENT_FAILURE";

export const GET_LEVEL1_BY_LEVEL_UPDATED_REQUEST =
  "GET_LEVEL1_BY_LEVEL_UPDATED_REQUEST";
export const GET_LEVEL1_BY_LEVEL_UPDATED_SUCCESS =
  "GET_LEVEL1_BY_LEVEL_UPDATED_SUCCESS";
export const GET_LEVEL1_BY_LEVEL_UPDATED_FAILURE =
  "GET_LEVEL1_BY_LEVEL_UPDATED_FAILURE";

export const GET_LEVEL2_BY_LEVEL_UPDATED_REQUEST =
  "GET_LEVEL2_BY_LEVEL_UPDATED_REQUEST";
export const GET_LEVEL2_BY_LEVEL_UPDATED_SUCCESS =
  "GET_LEVEL2_BY_LEVEL_UPDATED_SUCCESS";
export const GET_LEVEL2_BY_LEVEL_UPDATED_FAILURE =
  "GET_LEVEL2_BY_LEVEL_UPDATED_FAILURE";

export const GET_LEVEL3_BY_LEVEL_UPDATED_REQUEST =
  "GET_LEVEL3_BY_LEVEL_UPDATED_REQUEST";
export const GET_LEVEL3_BY_LEVEL_UPDATED_SUCCESS =
  "GET_LEVEL3_BY_LEVEL_UPDATED_SUCCESS";
export const GET_LEVEL3_BY_LEVEL_UPDATED_FAILURE =
  "GET_LEVEL3_BY_LEVEL_UPDATED_FAILURE";

export const GET_LEVEL4_BY_LEVEL_UPDATED_REQUEST =
  "GET_LEVEL4_BY_LEVEL_UPDATED_REQUEST";
export const GET_LEVEL4_BY_LEVEL_UPDATED_SUCCESS =
  "GET_LEVEL4_BY_LEVEL_UPDATED_SUCCESS";
export const GET_LEVEL4_BY_LEVEL_UPDATED_FAILURE =
  "GET_LEVEL4_BY_LEVEL_UPDATED_FAILURE";

export const SPLIT_QTY_REQUEST = "SPLIT_QTY_REQUEST";
export const SPLIT_QTY_SUCCESS = "SPLIT_QTY_SUCCESS";
export const SPLIT_QTY_FAILURE = "SPLIT_QTY_FAILURE";
